(function($) {
    function detectTouchscreen() {
        var result = false;
        if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
            // if Pointer Events are supported, just check maxTouchPoints
            if (navigator.maxTouchPoints > 0) {
            result = true;
            }
        } else {
            // no Pointer Events...
            if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
            // check for any-pointer:coarse which mostly means touchscreen
            result = true;
            } else if (window.TouchEvent || ('ontouchstart' in window)) {
            // last resort - check for exposed touch events API / event handler
            result = true;
            }
        }
        return result;
    }

    isTouch = detectTouchscreen();

    var timer = null, prompt_active = false;
    window.addEventListener('scroll', function() {
        prompt_active = true;
        if(timer !== null) {
            clearTimeout(timer);        
        }
        timer = setTimeout(function() {
            
            if(prompt_active == true){
                $('.interactive_map .instructions').css({
                    'opacity': 0
                });
            }
        }, 1000);
    }, false);



    function interactive_map_load(){

        //Set up variables
        var $panZoomedScale = 1,
        $panZoomedScaleOffset,
        $panZoomedX,
        $panZoomedY,
        $closeable = false,
        $ready = false;

        // just grab a DOM element
        var $panZoomContainer = document.querySelector('#map_container');

        var $initialZoom = window.innerWidth / 2400;

        if(window.innerWidth < 767){
            $initialZoom = 1;
        }

        

        console.log($initialZoom);

        // And pass it to panzoom
        var $panZoom = panzoom($panZoomContainer, {
            maxZoom: 5,
            minZoom: $initialZoom,
            initialZoom: $initialZoom,
            bounds: true,
            boundsPadding: 0.8,

            beforeWheel: function(e) {
                // allow wheel-zoom only if altKey is down. Otherwise - ignore
                if( (!e.ctrlKey && !e.metaKey) == true && isTouch == false){
                    if(window.navigator.platform.match(/mac/i) ){
                        $('.interactive_map .instructions').html('Hold Command + scroll to zoom').css({
                            'opacity': 0.75
                        });
                    } else {
                        $('.interactive_map .instructions').html('Hold Control + scroll to zoom').css({
                            'opacity': 0.75
                        });
                    }
                }
                
                return (!e.ctrlKey && !e.metaKey);
            }
        });


        function siteReady(){
            if($ready == false){
                $ready = true;
                $('.map_loading').fadeOut(200,function(){
                    $(this).remove();
                });

                var theX = window.innerWidth / 2, theY = $('.interactive_map .map').innerHeight() / 2;

                if(window.innerWidth < 1024){
                    theX = 300;
                    theY = 10;
                }

                if(window.innerWidth < 767){
                    theX = 2000;
                    theY = $('.interactive_map .map').innerHeight() / 2;
                }

                setTimeout(function(){
                    $panZoom.moveTo(0, 0);
                },950);
                setTimeout(function(){
                    
                    $panZoom.smoothZoomAbs(
                        theX, // initial x position
                        theY, // initial y position
                        $initialZoom + 0.1,  // initial zoom
                        1000 //Custom added animate speed
                    );
                },1000);
            }
        }

        $('.interactive_map .map').on('load', function(){
            siteReady();
        });
        //If the above code doesn't fire after 5 seconds, just assume it might be ready
        setTimeout(function(){
            if($('.map_loading').length){
                siteReady();
            }
        },5000);


        function adjustZoom(){
            //Offset the scale of plots against panzoom
            $panZoomedScale = $panZoom.getTransform().scale;
            if(window.innerWidth > 767){
                $panZoomedScaleOffset = 1 / $panZoomedScale;
            } else {
                $panZoomedScaleOffset = 0.7 / $panZoomedScale;
            }

            $('.interactive_map .plot_container').css({
                '-webkit-transform': 'scale('+$panZoomedScaleOffset+')',
                '-o-transform': 'scale('+$panZoomedScaleOffset+')',
                '-moz-transform': 'scale('+$panZoomedScaleOffset+')',
                '-ms-transform': 'scale('+$panZoomedScaleOffset+')',
                'transform': 'scale('+$panZoomedScaleOffset+')'
            });

            $panZoomContainer.style.display='none';
            $panZoomContainer.style.display='';
        }

        $panZoom.on('zoom', function(e) {
            adjustZoom();
        });


        $(document).on('click touchend','.interactive_map .plot_container .plot', function() {
            
            //Set variables of different container levels
            var $mapSection = $(this).closest('.interactive_map'),
                $mapContainer = $(this).closest('.map_container'),
                $container = $(this).parent('.plot_container'),
                $gallery = $(this).siblings('.content').find('.gallery');

            $gallery.find('img').each(function(){
                $(this).attr('src', $(this).attr('data-image-src'));
                $(this).removeAttr('data-image-src');
            });
                
            //Get the coordinaes of the selected plot
            var $adjustmentX, $adjustmentY;
            if(window.innerWidth > 1023){
                $adjustmentX = 6;
                $adjustmentY = 10;
            } else {
                $adjustmentX = 20;
                $adjustmentY = 20;
            }

            var $x = (($container.position().left * -1 ) + ($mapSection.innerWidth() / $adjustmentX)) / $panZoomedScale,
                $y = (($container.position().top * -1) + ($mapSection.innerHeight() / $adjustmentY)) / $panZoomedScale;


            //Get the panzoom offsets
            $panZoomedX = (Math.round($container.position().left + ($container.width() / 2)) * -1) + Math.round($mapSection.width() / 2);
            $panZoomedY = (Math.round($container.position().top + ($container.height() / 2)) * -1) + Math.round($mapSection.height() / 2);
            
            
            //Undo any current active plots, lock the containers scroll and zoom out
            $('.plot_container').removeClass('hover');

            $mapSection.addClass('zoomed');

            //Show the content
            $container.addClass('hover');

            //Disable Panzoom
            $panZoom.pause();

            //Move Panzoom to 0 0
            $panZoom.moveTo(0,0);

            //Reset any playing videos (if clicking next/prev)
            $('.slick-slide').find('video').each(function(){
                pauseVideo($(this),true);
            });
            
            $closeable = false;
            setTimeout(function(){
                $closeable = true;
            },1050);

            //Zoom and move to that plot
            $mapContainer.css({
                'transition': 'all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                'transform':  'translate('+$x+'px,'+$y+'px)'
            });

            $('#map_container').css({
                'transition': 'transform 1s cubic-bezier(0.645, 0.045, 0.355, 1.000)'
            });

            
            if($gallery.hasClass('slick-initialized') && $gallery.find('.slick-slide').width() < 100){
                $gallery.slick('unslick');
            }

            setTimeout(function(){
                //Enable slick slide gallery if it has one
                
                    $gallery.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true,
                        centerMode: false,
                        customPaging: function (slider, i) {
                            return  (i + 1) + '/' + slider.slideCount;   
                        },
                        responsive: [
                            {
                                breakpoint: 1023,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                }
                            }
                        ]
                    }).on('beforeChange',function(event, slick, currentSlide, nextSlide){
                        $('.slick-slide').find('video').each(function(){
                            pauseVideo($(this),true);
                        });
                    });
            },20);
        });

        function playVideo(video){
            video.get(0).play();
            video.prop("controls",true);
            video.next('.video_control.play').css({display: 'none'});
        }

        function pauseVideo(video,reset){
            video.get(0).pause();
            video.prop("controls",''); 
            if(reset == true){
                video.get(0).currentTime = 1;
            }
            video.next('.video_control.play').css({display: 'block'});
        }

        $(document).on('click','.interactive_map .gallery .video_control.play', function(){
            var $video = $(this).prev('video');
            playVideo($video);
        });

        if($('.interactive_map .gallery video').length){
            $('.interactive_map .gallery video').get(0).onended = function() {
                pauseVideo($(this),true);
            };
        }

        


        $(document).on('click touchstart','.interactive_map .plot_container .fa-close', function(){
            if($closeable == true){
                //Set variables of different container levels
                var $mapSection = $(this).closest('.interactive_map'),
                    $mapContainer = $(this).closest('.map_container');
                
                $('.plot_container').removeClass('hover');
                $mapSection.css({ 'overflow': ''});
                $mapContainer.css({
                    'transition': 'all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                    '-webkit-transform': '',
                    '-o-transform': '',
                    '-moz-transform': '',
                    '-ms-transform': '',
                    'transform': ''
                });

                $mapSection.removeClass('zoomed');

                //Enable Panzoom
                $panZoom.resume();
                $panZoom.moveTo($panZoomedX,$panZoomedY);

                $('.slick-slide').find('video').each(function(){
                    pauseVideo($(this),true);
                });

                setTimeout(function(){
                    $('#map_container').css({
                        'transition': ''
                    });
                },1000);
                $closeable = false;
            }
        });





        //Fire the close event if clicked off
        $(document).on('click','.interactive_map .map_container', function(e){
            if(e.target.className == 'plot_container hover'){
                $('.interactive_map .plot_container .fa-close').trigger('click');
            }
        });

        //Fire the close event if ESC key is pressed
        $(window).on('keyup',function(e) {
            if(e.key === "Escape") {
                $('.interactive_map .plot_container .fa-close').trigger('click');
            }
            if(e.key === "ArrowRight") {
                $('.interactive_map .plot_container.hover .next_plot').trigger('click');
            }
            if(e.key === "ArrowLeft") {
                $('.interactive_map .plot_container.hover .prev_plot').trigger('click');
            }
        });
        
        var resizeTimer;
        function map_plot_pins_init(){
            window.clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function(){
                $('.interactive_map .plot_container.hover .plot').trigger('click');
            },50);

            $('.interactive_map .plot_container').each(function(){
                
                var plotX = $(this).attr('data-left'),
                    plotY = $(this).attr('data-top');
            
                if(window.innerWidth < 768){
                    plotX -= 1;
                    plotY -= 2.5;
                }

                $(this).css({left: plotX+'%', top: plotY+'%'})
            });
            adjustZoom();
        }

        
        $(window).on('resize',function(){
            map_plot_pins_init();
        });

        $(document).ready(function(){
            map_plot_pins_init();
        });



        $(document).on('click','.interactive_map .next_plot', function(){
            var theNext = $(this).closest('.plot_container').next('.plot_container'),
                theFirst = $(this).closest('.map_container').children('.plot_container:first-of-type');
            if(theNext.length > 0){
                theNext.find('.plot').trigger('click');
            } else {
                theFirst.find('.plot').trigger('click');
            }
        });

        $(document).on('click','.interactive_map .prev_plot', function(){
            var thePrev = $(this).closest('.plot_container').prev('.plot_container'),
                theLast = $(this).closest('.map_container').children('.plot_container:last-of-type');
            if(thePrev.length > 0){
                thePrev.find('.plot').trigger('click');
            } else {
                theLast.find('.plot').trigger('click');
            }
        });

    }

    if( $('.interactive_map').length ){
        interactive_map_load();
    }
})( jQuery );